import PropTypes from 'prop-types';
import { ProductomodalContainer, styles } from '../productosComponents';

function ImageContainer({ preview, handleImageSelection }) {
  const classes = styles;

  return (
    <ProductomodalContainer>
      <div className='img-wrap'>
        <img
          alt='nuestra imagen'
          style={{
            width: '100%',
            maxWidth: '300px',
            padding: '2rem',
          }}
          src={preview}
        />
      </div>
      <div className={classes.root}>
        <input accept='.jpeg,.png, .jpg' className={classes.input} onChange={handleImageSelection} id='contained-button-file' type='file' />
      </div>
    </ProductomodalContainer>
  );
}

ImageContainer.propTypes = {
  preview: PropTypes.string,
  handleImageSelection: PropTypes.func,
};

export default ImageContainer;
